import { sajuApi, sajuQueryKeys } from '@entities/saju'
import { selectActiveEntry, usePollingStore } from '@shared/store/use-polling-store'
import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

const POLLING_INTERVAL = 10_000 // 10초

export function useGlobalPolling() {
  const activeEntry = usePollingStore((s) => selectActiveEntry(s.entries))
  const setCompleted = usePollingStore((s) => s.setCompleted)
  const remove = usePollingStore((s) => s.remove)

  const { data, error } = useQuery({
    queryKey: sajuQueryKeys.aiReadingStatus(
      activeEntry?.sajuType ?? 'classic',
      activeEntry?.hashKey ?? '',
    ),
    queryFn: () =>
      sajuApi.aiReadingStatus(activeEntry?.sajuType ?? 'classic', activeEntry?.hashKey ?? ''),
    enabled: activeEntry?.status === 'polling',
    refetchInterval: (query) => {
      if (query.state.data?.status === 'COMPLETED') {
        return false
      }
      return POLLING_INTERVAL
    },
  })

  // 완료 → store 동기화, 에러 → entry 제거 (에러 자체는 React Query 캐시)
  useEffect(() => {
    if (!activeEntry?.hashKey) {
      return
    }
    if (error) {
      remove(activeEntry.hashKey)
      return
    }
    if (data?.status === 'COMPLETED' && data.result) {
      setCompleted(activeEntry.hashKey)
    }
  }, [data, error, activeEntry?.hashKey, setCompleted, remove])
}
